/* Samedi light theme, round 43 (22 Sep 2026). Shopify renders the policy pages from the store's
   own policy text, which we never edit. Some of that text uses short ALL CAPS lines as headings
   ("WHERE WE SHIP", "1. WHO WE ARE"). This turns those lines into real headings so the page reads
   like the rest of the site. Presentation only: no wording is changed. */
(function () {
  var body = document.querySelector('.shopify-policy__body .rte');
  if (!body) return;
  var kids = [].slice.call(body.children);
  kids.forEach(function (el, i) {
    if (el.tagName !== 'P') return;
    var t = (el.textContent || '').trim();
    if (!t || t.length > 70 || el.querySelector('a,ul,ol')) return;
    var letters = t.replace(/[^A-Za-z]/g, '');
    if (!letters) return;
    var upper = letters === letters.toUpperCase();
    if (!upper) return;
    var h = document.createElement('h2');
    h.className = 'lp-policy-h';
    h.textContent = t.replace(/\s+/g, ' ');
    el.replaceWith(h);
    if (i === 0) h.classList.add('lp-policy-h--first');
  });
  // the "Last updated" line gets plain body styling on every policy, not the heading treatment
  [].slice.call(body.children).slice(0, 3).forEach(function (el) {
    if (/^last updated/i.test((el.textContent || '').trim())) {
      el.classList.remove('lp-policy-h', 'lp-policy-h--first');
      el.classList.add('lp-policy-updated');
    }
  });
  // some policies repeat their own title as the first ALL CAPS line: hide that duplicate
  var title = (document.querySelector('.shopify-policy__title h1') || {}).textContent || '';
  title = title.trim().toLowerCase().replace(/[^a-z]/g, '');
  if (title) {
    [].slice.call(body.children).slice(0, 2).forEach(function (el) {
      var t = (el.textContent || '').trim().toLowerCase().replace(/[^a-z]/g, '');
      if (t && t === title) el.classList.add('lp-policy-dupe');
    });
  }
})();
